import { BudgetMemberRole } from '@/components/organisms/budget/form-steps/budgetStep.schema';

export const BUDGET_MEMBER_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: 'internal_employee', label: 'Internal Employee' },
  { value: 'external_collaborator', label: 'External Collaborator' }
];

export const MEMBER_ROLE_LABELS: Record<BudgetMemberRole, string> = {
  owner: 'Owner',
  validation: 'Validator',
  staff: 'Staff'
};

export const MEMBER_ROLE_ACTION_OPTIONS = [
  { value: 'validation', label: 'Validator' },
  { value: 'staff', label: 'Staff' },
  { value: 'remove_access', label: 'Remove Access' }
] as const;
